import { gql } from "@apollo/client";

export const existuser = gql`
  query DA_adduser_check($email: String) {
    aatmsv4_users(where: { email: { _eq: $email } }) {
      active
    }
  }
`;

export const Client = gql`
  query DA_Adduser_dropdown1 {
    aatmsv4_clients(
      where: { active: { _eq: true } }
      order_by: { clientname: asc }
    ) {
      clientname
      clientsid
      department
    }
  }
`;
export const Fleets = gql`
  query DA_Addnewuser_dropdown2($id: uuid) {
    aatmsv4_fleets(
      where: { clientsid: { _eq: $id }, _and: { active: { _eq: true } } }
      order_by: { aircraft: asc }
    ) {
      aircraft
      fleetsid
    }
  }
`;
export const Ranks = gql`
  query Da_AddUser_Dropdown3($id: uuid) {
    aatmsv4_ranks(
      order_by: { rank: asc }
      where: { clientsid: { _eq: $id }, _and: { active: { _eq: true } } }
    ) {
      rank
      ranksid
    }
  }
`;
export const Airports = gql`
  query Da_adduser_dropdown4 {
    aatmsv4_airports(
      order_by: { icao: asc }
      where: { active: { _eq: true } }
    ) {
      icao
      airport
    }
  }
`;
export const Manager = gql`
  query Da_adduser_dropdown5($id: uuid) {
    aatmsv4_managers(
      order_by: { managername: asc }
      where: { clientsid: { _eq: $id }, _and: { active: { _eq: true } } }
    ) {
      managersid
      managername
    }
  }
`;
export const Qualicheck1 = gql`
  query Qualicheck1($id: String) {
    aatmsv4_qualifications(
      order_by: { qcode: asc }
      where: {
        clientsid: { _eq: "434ebeec-39d6-452f-8ad0-3f3e91c6c434" }
        active: { _eq: true }
      }
    ) {
      clientsid
      qid
      qcode
      qualification
      qualificationrecords(where: { validdate: { _lte: "2021-12-01" } }) {
        qrid
      }
    }
  }
`;

export const MissingQ = gql`
  query MissingQ($id: String) {
    aatmsv4_missingq(
      where: { crewid: { _eq: "mBfxFo7DKoYifaRdwFa7uZYbn9j1" } }
    ) {
      crewid
    }
  }
`;

export const Delete_Record = gql`
  mutation($id: uuid) {
    aatmsv4_missingq(
      where: { crewid: { _eq: "mBfxFo7DKoYifaRdwFa7uZYbn9j1" } }
    ) {
      returning {
        affected_rows
      }
    }
  }
`;

// export const delete_aatms_fleets = gql`
//   mutation da_fleets_delete($id: uuid, $active: Boolean) {
//     update_aatmsv4_fleets(
//       where: { fleetsid: { _eq: $id } }
//       _set: {
//         active: $active
//         _crew: false
//         _ground: false
//         _simulator: false
//         _aircraft: false
//         _manager: false
//         _optimiser: false
//       }
//     ) {
//       returning {
//         clientsid
//         clientname
//         fleetsid
//         aircraft
//         active
//         _crew
//         _ground
//         _simulator
//         _aircraft
//         _manager
//         _optimiser
//       }
//     }
//   }
// `;

export const insert_aatms_fleets = gql`
  mutation da_fleets_add(
    $clientid: uuid!
    $clientname: String!
    $aircraft: String!
  ) {
    insert_aatmsv4_fleets(
      objects: {
        clientname: $clientname
        clientsid: $clientid
        aircraft: $aircraft
        active: true
        _crew: true
        _ground: true
        _simulator: true
        _aircraft: true
        _manager: true
        _optimiser: true
      }
    ) {
      returning {
        clientsid
        clientname
        fleetsid
        aircraft
        active
        _ground
        _simulator
        _aircraft
        _crew
        _manager
        _optimiser
      }
    }
  }
`;

// export const Insert_Record = gql`
//   mutation($id: String) {
//     aatmsv4_missingq(
//         objects: {
//             userid: $userid
//           }
//     ) {
//       returning {

//       }
//     }
//   }
// `;

export const Add_User_Register = gql`
  mutation da_adduser_add1(
    $birthdate: date
    $userid: String
    $clientsid: uuid
    $ecode: String
    $emailofficial: String
    $emailpersonal: String
    $fleetsid: uuid
    $icao: String
    $joindate: date
    $licence: String
    $managersid: String
    $name: String
    $phone1: String
    $phone2: String
    $managername: String
    $photo: String
    $pmtaddress: String
    $ranksid: uuid
    $clientname: String
    $tempaddress: String
    $_optimiser: Boolean
    $_simulator: Boolean
    $department: Boolean
    $_aircraft: Boolean
    $_crew: Boolean
    $_dataadmin: Boolean
    $_ground: Boolean
    $_manager: Boolean
    $active: Boolean
  ) {
    insert_aatmsv4_register(
      objects: {
        userid: $userid
        clientsid: $clientsid
        fleetsid: $fleetsid
        ranksid: $ranksid
        ecode: $ecode
        emailofficial: $emailofficial
        name: $name
        icao: $icao
        phone1: $phone1
        phone2: $phone2
        emailpersonal: $emailpersonal
        birthdate: $birthdate
        joindate: $joindate
        licence: $licence
        pmtaddress: $pmtaddress
        tempaddress: $tempaddress
        managersid: $managersid
        adminapproved: $active
        photo: $photo
        roleallotted: false
        aircraft: $_aircraft
        crew: $_crew
        dataadmin: $_dataadmin
        ground: $_ground
        managers: $_manager
        optimiser: $_optimiser
        simulator: $_simulator
      }
    ) {
      returning {
        emailofficial
      }
    }
  }
`;
export const Add_User_UserTable = gql`
  mutation da_adduser_add2(
    $fleetsid: uuid
    $clientsid: uuid
    $emailofficial: String
    $userid: String
    $active: Boolean
    $_optimiser: Boolean
    $_simulator: Boolean
    $_aircraft: Boolean
    $_crew: Boolean
    $_dataadmin: Boolean
    $_ground: Boolean
    $_manager: Boolean
  ) {
    insert_aatmsv4_users(
      objects: {
        userid: $userid
        clientid: $clientsid
        fleetid: $fleetsid
        email: $emailofficial
        managed: false
        pending: false
        active: $active
        _aircraft: $_aircraft
        _crew: $_crew
        _dataadmin: $_dataadmin
        _ground: $_ground
        _manager: $_manager
        _optimiser: $_optimiser
        _simulator: $_simulator
      }
    ) {
      returning {
        email
      }
    }
  }
`;
export const addUser_Optimiser = gql`
  mutation da_adduser_addOptimiser(
    $_optimiser: Boolean
    $clientsid: uuid
    $department: String
    $ecode: String
    $emailofficial: String
    $fleetsid: uuid
    $name: String
    $photo: String
    $ranksid: uuid
    $usersid: String
  ) {
    insert_aatmsv4_optimiser(
      objects: {
        usersid: $usersid
        clientsid: $clientsid
        fleetsid: $fleetsid
        ranksid: $ranksid
        ecode: $ecode
        emailofficial: $emailofficial
        name: $name
        active: $_optimiser
        department: $department
        photo: $photo
      }
    ) {
      returning {
        emailofficial
      }
    }
  }
`;
export const AddUser_Crew = gql`
  mutation da_adduser_addCrew(
    $pmtaddress: String
    $tempaddress: String
    $birthdate: date
    $clientsid: uuid
    $crewid: String
    $ecode: String
    $emailpersonal: String
    $fleetsid: uuid
    $joindate: date
    $licence: String
    $managersid: String
    $name: String
    $icao: String
    $phone1: String
    $phone2: String
    $photo: String
    $ranksid: uuid
    $emailofficial: String
    $_crew: Boolean
  ) {
    insert_aatmsv4_crews(
      objects: {
        crewid: $crewid
        clienstid: $clientsid
        fleetsid: $fleetsid
        ranksid: $ranksid
        ecode: $ecode
        email: $emailofficial
        name: $name
        icao: $icao
        phone1: $phone1
        phone2: $phone2
        emailpersonal: $emailpersonal
        birthdate: $birthdate
        joiningdate: $joindate
        license: $licence
        addresspmt: $pmtaddress
        addresstemp: $tempaddress
        managersid: $managersid
        active: $_crew
        approved: true
        photo: $photo
      }
    ) {
      returning {
        email
      }
    }
  }
`;
export const Add_User_Ground = gql`
  mutation da_adduser_addGround(
    $licence: String
    $birthdate: date
    $clientsid: uuid
    $ecode: String
    $emailofficial: String
    $emailpersonal: String
    $joindate: date
    $managersid: String
    $name: String
    $phone1: String
    $phone2: String
    $photo: String
    $pmtaddress: String
    $ranksid: uuid
    $tempaddress: String
    $userid: String
    $_ground: Boolean
  ) {
    insert_aatmsv4_groundinst(
      objects: {
        userid: $userid
        clientsid: $clientsid
        ranksid: $ranksid
        ecode: $ecode
        Licence: $licence
        emailofficial: $emailofficial
        name: $name
        phone1: $phone1
        phone2: $phone2
        emailpersonal: $emailpersonal
        birthdate: $birthdate
        joindate: $joindate
        pmtaddress: $pmtaddress
        tempaddress: $tempaddress
        managersid: $managersid
        active: $_ground
        photo: $photo
      }
    ) {
      returning {
        emailofficial
      }
    }
  }
`;
export const AddUser_Aircraft = gql`
  mutation da_adduser_addAircraft(
    $icao: String
    $name: String
    $birthdate: date
    $clientsid: uuid
    $ecode: String
    $emailofficial: String
    $fleetsid: uuid
    $joindate: date
    $licence: String
    $managersid: String
    $phone1: String
    $phone2: String
    $photo: String
    $pmtaddress: String
    $ranksid: uuid
    $usersid: String
    $tempaddress: String
    $emailpersonal: String
    $_aircraft: Boolean
  ) {
    insert_aatmsv4_aircraftinst(
      objects: {
        usersid: $usersid
        clientsid: $clientsid
        fleetsid: $fleetsid
        ranksid: $ranksid
        ecode: $ecode
        emailofficial: $emailofficial
        name: $name
        base: $icao
        phone1: $phone1
        phone2: $phone2
        emailpersonal: $emailpersonal
        birthdate: $birthdate
        joindate: $joindate
        licence: $licence
        pmtaddress: $pmtaddress
        tempaddress: $tempaddress
        managersid: $managersid
        active: $_aircraft
        photo: $photo
      }
    ) {
      returning {
        emailofficial
      }
    }
  }
`;
export const AddUser_Manager = gql`
  mutation da_adduser_addManager(
    $_aircraft: Boolean
    $_crew: Boolean
    $_ground: Boolean
    $_manager: Boolean
    $_optimiser: Boolean
    $_simulator: Boolean
    $active: Boolean
    $birthdate: date
    $clientname: String
    $clientsid: uuid
    $emailpersonal: String
    $ecode: String
    $icao: String
    $joindate: date
    $emailofficial: String
    $managername: String
    $usersid: String
    $phone1: String
    $phone2: String
    $photo: String
    $pmtaddress: String
    $tempaddress: String
    $resmanager: String
  ) {
    insert_aatmsv4_managers(
      objects: {
        clientsid: $clientsid
        manageremail: $emailofficial
        managername: $managername
        managersid: $usersid
        resmanager: $resmanager
        icao: $icao
        phone1: $phone1
        phone2: $phone2
        emailpersonal: $emailpersonal
        birthdate: $birthdate
        joindate: $joindate
        pmtaddress: $pmtaddress
        tempaddress: $tempaddress
        clientname: $clientname
        photo: $photo
        employeeid: $ecode
        _aircraft: $_aircraft
        _crew: $_crew
        _ground: $_ground
        _manager: $_manager
        _optimiser: $_optimiser
        _simulator: $_simulator
        active: $active
      }
    ) {
      returning {
        manageremail
      }
    }
  }
`;
export const AddUser_Simulator = gql`
  mutation da_adduser_addSimulator(
    $icao: String
    $name: String
    $birthdate: date
    $clientsid: uuid
    $ecode: String
    $emailofficial: String
    $emailpersonal: String
    $fleetsid: uuid
    $joindate: date
    $licence: String
    $managersid: String
    $phone1: String
    $phone2: String
    $photo: String
    $pmtaddress: String
    $ranksid: uuid
    $id: String
    $tempaddress: String
    $_simulator: Boolean
  ) {
    insert_aatmsv4_simulatorinst(
      objects: {
        usersid: $id
        clientsid: $clientsid
        fleetsid: $fleetsid
        ranksid: $ranksid
        ecode: $ecode
        emailofficial: $emailofficial
        name: $name
        base: $icao
        phone1: $phone1
        phone2: $phone2
        emailpersonal: $emailpersonal
        birthdate: $birthdate
        joindate: $joindate
        licence: $licence
        pmtaddress: $pmtaddress
        tempaddress: $tempaddress
        managersid: $managersid
        active: $_simulator
        photo: $photo
      }
    ) {
      returning {
        emailofficial
      }
    }
  }
`;
export const dataAdminsss = gql`
  mutation da_adduser_addSimulator(
    $_dataadmin: Boolean
    $name: String
    $clientsid: uuid
    $ecode: String
    $emailofficial: String
    $fleetsid: uuid
    $photo: String
    $ranksid: uuid
    $userid: String
    $department: String
  ) {
    insert_aatmsv4_dataadmin(
      objects: {
        userid: $userid
        clientsid: $clientsid
        fleetsid: $fleetsid
        ranksid: $ranksid
        ecode: $ecode
        email: $emailofficial
        name: $name
        active: $_dataadmin
        photo: $photo
        department: $department
      }
    ) {
      returning {
        email
      }
    }
  }
`;
